require("!!C:\\projects\\angesqc-mercure\\aspnet-core\\src\\AngesQc.Mercure.Web.Static\\node_modules\\script-loader\\addScript.js")(require("!!C:\\projects\\angesqc-mercure\\aspnet-core\\src\\AngesQc.Mercure.Web.Static\\node_modules\\raw-loader\\index.js!C:\\projects\\angesqc-mercure\\aspnet-core\\src\\AngesQc.Mercure.Web.Static\\node_modules\\startbootstrap-sb-admin\\js\\sb-admin-datatables.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/startbootstrap-sb-admin/js/sb-admin-datatables.min.js
// module id = mKWM
// module chunks = 0